export const MENU_TRANSLATE = {
    menu: {
        notFound: {
            text: "No menu items"
        },
        loading: {
            text: "Loading menu"
        },
        breadcrumb: {
            actions: {
                menu: {
                    text: "Side menu"
                }
            }
        },
        toolbar: {
            title: "",
            adminTitle: "Administrator",
            actions: {
                logout: {
                    text: "Sign Out"
                },
                myProfile: {
                    text: "My Profile"
                },
                configurations: {
                    text: "Settings",
                    home: "Spaces",
                }
            }
        },

        group: {},
        items: {
            accounts: {
                name: "Accounts",
            },
            admins: {
                name: "Administrators",
            },
            users: {
                name: "Users"
            },
            categories: {
                name: "Categories"
            },
            committees: {
                name: "Committees"
            },
            complaints: {
                name: "Complaints"
            },
            languages: {
                name: "Languages"
            }
        }
    },
}
